import { ActionTimestamp } from "../action";
import { State } from "../state";
import { applyAchievementChecks } from "../Achievements/checkAchievements";
import { ApplyOutcomesBrickPack } from "../BrickActions/Actions/_CostsAndOutcomes/BrickPacks/ApplyOutcomesBrickPack";

export const processAutoCreate = (state: State) => {
  const newBricks = new Map(state.bricks);
  const newActionTimestamps = state.actionTimestamps;
  const newBricksCollectedByType = state.bricksCollectedByType;
  const newBrickPackHistory = state.brickPackHistory;
  const newBrickPackStats = state.brickPackStats;
  let newTotalCollected = state.totalBricksCollected;

  // Process individual brick auto-collect (existing logic)
  newBricks.forEach((brickEntry, _) => {
    // Skip if empty or not set
    if (brickEntry.autoCollect <= 0 || Number.isNaN(brickEntry.amount)) return;

    // Valid Auto Collect but at capacity
    if (brickEntry.amount >= brickEntry.capacity) return;

    let amtUpdated = 0;

    if (brickEntry.capacity - brickEntry.amount < brickEntry.autoCollect) {
      amtUpdated += brickEntry.capacity - brickEntry.amount;
    } else {
      amtUpdated += brickEntry.autoCollect;
    }

    // Apply Achievement Data
    newTotalCollected += amtUpdated;

    const newBricksAmt = newBricksCollectedByType.get(brickEntry.id) ?? 0;
    newBricksCollectedByType.set(brickEntry.id, newBricksAmt + amtUpdated);

    brickEntry.amount = Math.min(
      brickEntry.capacity,
      brickEntry.amount + brickEntry.autoCollect,
    );

    const timestamp: ActionTimestamp = {
      id: brickEntry.id,
      amount: brickEntry.autoCollect,
      timestamp: Date.now(),
    };

    newActionTimestamps.push(timestamp);
  });

  // Process brick pack auto-purchases (new logic)
  state.brickPackAutoCollect.forEach((purchasesPerSecond, brickpackId) => {
    if (purchasesPerSecond <= 0) return;

    // Get the brickpack action from actions Map
    const brickpackAction = state.actions.get(brickpackId);
    if (!brickpackAction) return;

    // Check if ANY brick in the pack has available capacity
    // If all bricks are at capacity, skip auto-purchase entirely
    const hasCapacityAvailable = brickpackAction.outcome.some((outcome) => {
      const brick = newBricks.get(outcome.brickId);
      if (!brick) return false;
      // Check if brick has room (either NaN which becomes 0, or less than capacity)
      return Number.isNaN(brick.amount) || brick.amount < brick.capacity;
    });

    if (!hasCapacityAvailable) return; // Skip if no capacity

    // Purchase the brickpack X times (without cost checks)
    // This applies find percentage rolls for each brick in the pack
    const result = ApplyOutcomesBrickPack(
      brickpackAction,
      newBricks,
      newActionTimestamps,
      purchasesPerSecond, // Total packs to purchase this second
      newBrickPackHistory,
      newBrickPackStats,
      state.brickPackUpgrades,
    );

    // Update achievement stats based on bricks added
    if (result !== null) {
      result.bricksAdded.forEach((count, brickId) => {
        newTotalCollected += count;
        const currentCount = newBricksCollectedByType.get(brickId) || 0;
        newBricksCollectedByType.set(brickId, currentCount + count);
      });
    }
  });

  const newState = {
    ...state,
    actionTimestamps: newActionTimestamps,
    bricks: newBricks,
    brickPackHistory: newBrickPackHistory,
    brickPackStats: newBrickPackStats,
    totalBricksCollected: newTotalCollected,
    bricksCollectedByType: newBricksCollectedByType,
  };

  return applyAchievementChecks(newState);
};
